"use client"
import { type FragmentOf, readFragment } from "@opensea/graphql"
import { Flex, UnstyledButton } from "@opensea/ui-kit"
import { useState } from "react"
import { PreviewImage } from "./PreviewImage"
import { PreviewImagesFragment } from "./PreviewImages.fragment"

type PreviewImagesProps = {
  collection: FragmentOf<typeof PreviewImagesFragment> | null
}

export function PreviewImages({
  collection: collectionKey,
}: PreviewImagesProps) {
  const collection = readFragment(PreviewImagesFragment, collectionKey)
  const [selectedImageIndex, setSelectedImageIndex] = useState(0)

  if (!collection?.about?.previewMedia) {
    return null
  }

  const { previewMedia } = collection.about

  return (
    <>
      <PreviewImage media={previewMedia[selectedImageIndex]} />
      {previewMedia.length > 1 ? (
        <Flex className="mt-4 gap-4">
          {previewMedia.map((media, index) => (
            <UnstyledButton
              className={`basis-1/4 cursor-pointer overflow-hidden rounded-lg ${
                selectedImageIndex === index ? "border border-border-2" : ""
              }`}
              key={index}
              onClick={() => setSelectedImageIndex(index)}
            >
              <PreviewImage media={media} thumbnailOnly />
            </UnstyledButton>
          ))}
        </Flex>
      ) : null}
    </>
  )
}
